import React from 'react';
import { motion } from 'framer-motion';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo_without_text.png';
import { projectsData } from '../assets/projects-json/projectsData.js';

const ProjectSection = () => {
  const navigate = useNavigate();

  const settings = {
    dots: false,
    fade: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true,
    autoplaySpeed: 1000,
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const slideVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  return (
    <motion.div
      className="flex flex-col items-center justify-center p-2 lg:p-10 max-w-7xl mx-auto gap-y-10 text-center mt-5 lg:mt-10"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      <motion.div variants={containerVariants}>
        <h1 className="font-extrabold text-2xl lg:text-4xl text-gray-700">Recent Projects</h1>
        <p className="font-semibold text-xl lg:text-2xl mt-2 text-gray-700">
          We follow a well-defined development procedure to take an application from ideation to actualization, aiming to provide innovative app
          development solutions to our clients.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-3 gap-6 w-full">
        {projectsData.slice(-3).map((project, i) => (
          <motion.div
            key={project.id}
            className="rounded-2xl"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
            variants={containerVariants}
            transition={{ delay: i * 0.2 }}
          >
            <Slider {...settings}>
              {project.thumbnails.map((thumbnail, index) => (
                <motion.div key={index} className="px-2 rounded-2xl relative" variants={slideVariants}>
                  <img className="w-20 absolute z-10" src={logo} alt="logo" />
                  <img className="rounded-2xl w-full" src={thumbnail} alt={`slide-${index}`} />
                </motion.div>
              ))}
            </Slider>
            <div className="flex justify-between items-center gap-x-3 mt-3 px-2">
              <motion.h1
                className="text-justify text-lg font-semibold cursor-pointer"
                variants={containerVariants}
                transition={{ delay: 0.4 }}
                onClick={() => navigate(`/projects/projectdetails/${project.id}`)} // Navigate by project id
              >
                {project.title}
              </motion.h1>
              <motion.button
                className="hover:bg-primaryColor group border border-primaryColor p-2 rounded-full"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate(`/projects/projectdetails/${project.id}`)} // Navigate by project id
                // onClick={() => navigate(`/projects/${project.id}`)}
                aria-label="Project button"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6 stroke-primaryColor group-hover:stroke-white transition-colors duration-300"
                >
                  <path
                    d="M6 18L18 6M18 6H9M18 6V15"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </motion.button>
            </div>
          </motion.div>
        ))}
      </div>

      {/* View All Projects Button */}
      <div className="flex justify-center mt-6 w-full">
        <button
          onClick={() => navigate('/projects')}
          className="px-6 py-3 bg-primaryColor text-white rounded-full hover:bg-primaryColor-dark transition"
        >
          View All Projects
        </button>
      </div>
    </motion.div>
  );
};

export default ProjectSection;
